module.exports = __webpack_public_path__ + "img/5.efa09768.png";